import {gql} from '@apollo/client';

/**
 * Fetches the facts about a library parameter definition that decide whether a Reaction Condition can use it
 * and which units it accepts.
 */
export const REACTION_PARAMETER_UNIT_TYPE_QUERY = gql`
  query ReactionParameterUnitTypeQuery($id: StrictString!) @skipAudit @engComponent(name: PROCEDURES) {
    libraryParameterDefinition(id: $id) {
      id
      dataType
      unitType {
        id
      }
    }
  }
`;
